(function ($, Global) {
    function InsidersPage() {
        // Déclaration class objet
    }

	InsidersPage.prototype.initEvents = function () {
		this.publishers();
	}

    InsidersPage.prototype.publishers = function () {
        $(document).on('click', '.dossier-actions .btn-action', function () {
            if ($('.landing-box').exists()) {
                $('html, body').animate({
                    scrollTop: $('.landing-box').offset().top - 10
                }, 'slow');
            }
        });

        $(document).on('click', '.page-insiders .article img', function () {
            var windowWidth = $(window).width();

            if (windowWidth < Global.viewports.sm) return;
            var $img = $(this);

            var $grandparent = $img.closest('article.thumbnail');
            if ($grandparent.exists()) return;

            var src = $img.attr('src');
            var caption = $img.attr('title') || '';
            var params = $.getParams(src);
            var imgResize = new Global.ImageResize(params);

            var $parent = $img.parent();
            if ($parent.tagName() === 'FIGURE') {
                var $caption = $parent.find('figcaption');
                if ($caption.exists()) caption = $caption.html();
            }

            imgResize.width = 800;

            $.Topic('modal-img-fullscreen-load').publish(imgResize.getSrc(), caption);
            
        });
	}

	Global.InsidersPage = InsidersPage;
}(jQuery, window));